import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import {
  bulkAddAdminRole,
  bulkDeleteUsers,
  bulkRemoveAdminRole,
  deleteUser,
  getCompanyUsers,
  setCompanyUsersLoading,
  setUserCountry,
  setUserDivision,
  toggleUserStatus,
} from '../../store/UserManagementActions'
import {
  getAdminRoleInProgress,
  getBulkDeleteInProgress,
  getCompanyUsersWithRoles,
  getCompanyUsersLoading,
} from '../../store/UserManagementSelectors'
import {
  companyCountriesSelector,
  companyDivisionsSelector,
  managedCompaniesSelector,
  userCompaniesSelector,
} from '../../../Settings/store/SettingsSelectors'
import { getUserCompanyCountries, getCompanyDivisions } from '../../../Settings/store/SettingsActions'
import UserAdmin, { IUserAdminDispatchProps } from './UserAdmin'
import {
  getDivisionCategories as getDivisionCategoriesAction,
  //getDivisionsDeprecated as getDivisionsAction,
  setUserCategoryDivision,
} from '../../../TeamManagement/store/TeamManagementActions'
import {
  getDivisionCategories,
  //getDivisionsSelectorDeprecated,
} from '../../../TeamManagement/store/TeamManagementSelectors'
import { getCompanyAdminSelectedCompanyId } from '../../../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../../../CompanyAdmin/store/CompanyAdminActions'

const mapStateToProps = (state: IGlobalState) => ({
  companyUsers: getCompanyUsersWithRoles(state),
  usersLoading: getCompanyUsersLoading(state),
  divisions: companyDivisionsSelector(state),
  countries: companyCountriesSelector(state),
  managedCompanies: managedCompaniesSelector(state),
  userCompanies: userCompaniesSelector(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  bulkDeleteInProgress: getBulkDeleteInProgress(state),
  adminRoleInProgress: getAdminRoleInProgress(state),
  divisionCategories: getDivisionCategories(state),
  //companyGroups: getDivisionsSelectorDeprecated(state) || {},
})

const mapDispatchToProps: IUserAdminDispatchProps = {
  deleteUser,
  bulkDeleteUsers,
  bulkAddAdminRole,
  bulkRemoveAdminRole,
  getCompanyUsers,
  getUserCompanyCountries,
  //getCompanyDivisions,
  toggleUserStatus,
  setUserCountry,
  setUserDivision,
  setCompanyUsersLoading,
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  getDivisionCategories: getDivisionCategoriesAction,
  getDivisions: getCompanyDivisions,
  setUserCategoryDivision,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdmin)
